import { ListTodo, Clock, AlertTriangle, Calendar } from 'lucide-react'
import { StatsCard } from './StatsCard'
import { Skeleton } from '@/components/ui'

interface SupervisorStatsGridProps {
  firmActiveTasks: number
  teamHoursThisWeek: number
  overdueTasks: number
  upcomingDeadlines: number
  isLoading?: boolean
}

export function SupervisorStatsGrid({
  firmActiveTasks,
  teamHoursThisWeek,
  overdueTasks,
  upcomingDeadlines,
  isLoading,
}: SupervisorStatsGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-[120px] rounded-xl animate-shimmer" />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatsCard
        title="Firm Active Tasks"
        value={firmActiveTasks}
        icon={ListTodo}
        description="Across all team members"
      />
      <StatsCard
        title="Team Hours This Week"
        value={teamHoursThisWeek.toFixed(1)}
        icon={Clock}
        description="Total team hours logged"
      />
      <div className="relative">
        {overdueTasks > 0 && (
          <span className="absolute top-2 right-2 z-10 h-2.5 w-2.5 rounded-full bg-destructive animate-glow-pulse" />
        )}
        <StatsCard
          title="Overdue Tasks"
          value={overdueTasks}
          icon={AlertTriangle}
          alert={overdueTasks > 0}
          description={overdueTasks > 0 ? 'Needs attention' : 'All on track'}
        />
      </div>
      <StatsCard
        title="Upcoming Deadlines"
        value={upcomingDeadlines}
        icon={Calendar}
        description="Next 7 days"
      />
    </div>
  )
}
